import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2a388unpqo: FaireBrandEntity = {
  token: "b_2a388unpqo",
  type: "brand",
  name: "Bluivy",
  avatarUrl: "https://cdn.faire.com/fastly/4ac4dca27489a2024ad063420d9a22d62a885a89eac38affd97a4ae033e7790e.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/00d04979d6f938e5b4b1c8ddad852a2ddce602abf1fc1aae5e4c402006aa945b.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/4ac4dca27489a2024ad063420d9a22d62a885a89eac38affd97a4ae033e7790e.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/00d04979d6f938e5b4b1c8ddad852a2ddce602abf1fc1aae5e4c402006aa945b.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 2097,
  isTopShop: true,
  isInsider: true,
  description: "At Bluivy we are more than a brand off the shelf. Styles are curated with fit and feel in mind. Inspired by the laid back Californian lifestyle ranging from relaxed vibes to modern chic styles, we're the go-to clothing line for women seeking great quality garments with outstanding fit and designs. We aim to provide all our partners gorgeous, affordable clothing without surrendering quality, style, or comfort. ",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:45.517Z",
    importedBy: "entity-db-cli"
  }
};
